// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .credit-score-slider--39jIC{font-size:inherit}.precise-price-app .credit-score-slider__slider--1K7Il{max-width:320px;margin:0 auto}.precise-price-app .credit-score-slider__subtitle--2YQ7r{font-weight:700;color:var(--font-color)}.precise-price-app .credit-score-slider__description--2GjGe,.precise-price-app .credit-score-slider__subtitle--2YQ7r{font-size:var(--font-size);line-height:16px;text-align:center;margin-top:5px}.precise-price-app .credit-score-slider__center-button--1gWRM{margin:0 auto}.precise-price-app .credit-score-slider__link--2PXjs{margin-top:15px}", ""]);
// Exports
exports.locals = {
	"creditScoreSlider": "credit-score-slider--39jIC",
	"creditScoreSliderSlider": "credit-score-slider__slider--1K7Il",
	"creditScoreSliderSubtitle": "credit-score-slider__subtitle--2YQ7r",
	"creditScoreSliderDescription": "credit-score-slider__description--2GjGe",
	"creditScoreSliderCenterButton": "credit-score-slider__center-button--1gWRM",
	"creditScoreSliderLink": "credit-score-slider__link--2PXjs"
};
module.exports = exports;
